export const getInventoryStockCheckList = state => {
    return state.list
}

export const getInventoryStockCheckDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryStockCheck/getters.js